import React from "react";
import { Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderColor: "red", // Change the outline color to red
        },
      },
    },
  },
});
const ActionButton = (props) => {
  return (
    <div>
      <Button
        sx={{
          color: props.color,
          backgroundColor: props.backgroundColor,
          borderColor: props.borderColor,
          "&:hover": {
            borderColor: props.borderColor,
          },
        }}
        variant={props.variant}
      >
        {props.btnName}
      </Button>
    </div>
  );
};

export default ActionButton;
